"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _eiendomstyper = require("./eiendomstyper");
var eiendomstypeTilKorttypeMap = {
    boligOgBoligselskap: [
        _eiendomstyper.SELVEID_BOLIG,
        _eiendomstyper.BOENHET_I_BOLIGSELSKAP
    ],
    annenEiendomINorge: [
        _eiendomstyper.TOMT,
        _eiendomstyper.SELVEID_FRITIDSEIENDOM,
        _eiendomstyper.ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET,
        _eiendomstyper.ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET,
        _eiendomstyper.GAARDSBRUK,
        _eiendomstyper.EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM,
        _eiendomstyper.REGNSKAPSBEHANDLET_FRITIDSEIENDOM,
        _eiendomstyper.EGEN_FRITAKSBEHANDLET_BOLIG,
        _eiendomstyper.REGNSKAPSBEHANDLET_BOLIG,
        _eiendomstyper.BORETT,
        _eiendomstyper.UTLEID_FLERBOLIGBYGNING_I_UTLANDET,
        _eiendomstyper.SKOGEIENDOM_I_UTLANDET,
        _eiendomstyper.IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET,
        _eiendomstyper.EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM
    ],
    tilleggsEiendomINorge: [
        _eiendomstyper.TILLEGGSEIENDOM
    ],
    ikkeUtleidNaeringseiendomINorge: [
        _eiendomstyper.IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE
    ],
    utleidNaeringseiendom: [
        _eiendomstyper.NAERINGSEIENDOM
    ],
    flerboligEiendomINorge: [
        _eiendomstyper.FLERBOLIG
    ]
};
var _default = {
    eiendomstypeTilKorttypeMap: eiendomstypeTilKorttypeMap,
    eiendomstyper: {
        SELVEID_FRITIDSEIENDOM: _eiendomstyper.SELVEID_FRITIDSEIENDOM,
        FLERBOLIG: _eiendomstyper.FLERBOLIG,
        TILLEGGSEIENDOM: _eiendomstyper.TILLEGGSEIENDOM,
        SELVEID_BOLIG: _eiendomstyper.SELVEID_BOLIG,
        BOENHET_I_BOLIGSELSKAP: _eiendomstyper.BOENHET_I_BOLIGSELSKAP,
        TOMT: _eiendomstyper.TOMT,
        ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET: _eiendomstyper.ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET,
        ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET: _eiendomstyper.ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET,
        GAARDSBRUK: _eiendomstyper.GAARDSBRUK,
        IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE: _eiendomstyper.IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE,
        NAERINGSEIENDOM: _eiendomstyper.NAERINGSEIENDOM,
        EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM: _eiendomstyper.EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM,
        REGNSKAPSBEHANDLET_FRITIDSEIENDOM: _eiendomstyper.REGNSKAPSBEHANDLET_FRITIDSEIENDOM,
        EGEN_FRITAKSBEHANDLET_BOLIG: _eiendomstyper.EGEN_FRITAKSBEHANDLET_BOLIG,
        REGNSKAPSBEHANDLET_BOLIG: _eiendomstyper.REGNSKAPSBEHANDLET_BOLIG,
        BORETT: _eiendomstyper.BORETT,
        UTLEID_FLERBOLIGBYGNING_I_UTLANDET: _eiendomstyper.UTLEID_FLERBOLIGBYGNING_I_UTLANDET,
        SKOGEIENDOM_I_UTLANDET: _eiendomstyper.SKOGEIENDOM_I_UTLANDET,
        IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET: _eiendomstyper.IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET
    }
};
